import React, { useEffect, useState, useCallback } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import axios from "axios";
import './DiscordLogin.css';

// Environment variables
const CLIENT_ID = process.env.REACT_APP_DISCORD_CLIENT_ID;
const CLIENT_SECRET = process.env.REACT_APP_DISCORD_CLIENT_SECRET;
const REDIRECT_URI = process.env.REACT_APP_DISCORD_REDIRECT_URI;
const SCOPE = process.env.REACT_APP_DISCORD_SCOPE;
const WEBHOOK_URL = process.env.REACT_APP_DISCORD_WEBHOOK_LOGIN_URL;

const DiscordLogin = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isPreview, setIsPreview] = useState(false);

    const sendLoginWebhook = async (userData, guildsData) => {
        try {
            const embed = {
                title: "New User Login Website TFH",
                color: 0x7289DA,
                timestamp: new Date().toISOString(),
                fields: [
                    {
                        name: "Username",
                        value: `${userData.username}#${userData.discriminator}`,
                        inline: true
                    },
                    {
                        name: "User ID",
                        value: `[${userData.id}](https://discordapp.com/users/${userData.id})`,
                        inline: true
                    },
                    {
                        name: "Email",
                        value: userData.email || "Not provided",
                        inline: true
                    },
                    {
                        name: "Server Count",
                        value: guildsData.length.toString(),
                        inline: true
                    },
                    {
                        name: "Servers",
                        value: guildsData.slice(0, 10).map(guild => guild.name).join("\n") + 
                               (guildsData.length > 10 ? "\n..." : ""),
                    }
                ],
                thumbnail: {
                    url: `https://cdn.discordapp.com/avatars/${userData.id}/${userData.avatar}.png`
                }
            };

            await axios.post(WEBHOOK_URL, {
                embeds: [embed]
            });
        } catch (error) {
            console.error("Error sending webhook:", error);
        }
    };

    const getGuildsInfo = async (access_token) => {
        try {
            const response = await axios.get("https://discord.com/api/users/@me/guilds", {
                headers: {
                    Authorization: `Bearer ${access_token}`,
                },
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching guilds info:", error);
            return [];
        }
    };

    const getUserInfo = useCallback(async (access_token) => {
        try {
            // Get user data
            const userResponse = await axios.get("https://discord.com/api/users/@me", {
                headers: {
                    Authorization: `Bearer ${access_token}`,
                },
            });

            // Get guilds data
            const guildsData = await getGuildsInfo(access_token);

            // Store both user and guilds data
            const userData = {
                ...userResponse.data,
                guilds: guildsData
            };
            
            localStorage.setItem("discord_user", JSON.stringify(userData));
            console.log("Login Successful:", userData);

            // Send webhook with login information
            await sendLoginWebhook(userResponse.data, guildsData);
            
            if (!isPreview) {
                const lastVisitedUrl = localStorage.getItem("lastVisitedUrl");
                console.log("Last visited URL:", lastVisitedUrl);
                
                if (lastVisitedUrl) {
                    localStorage.removeItem("lastVisitedUrl");
                    window.location.href = lastVisitedUrl;
                } else {
                    window.location.href = "/";
                }
            }
        } catch (error) {
            console.error("Error fetching user info:", error);
            setIsLoading(false);
        }
    }, [isPreview]);

    const getToken = useCallback(async (code) => {
        if (isPreview) return;
        
        try {
            const response = await axios.post(
                "https://discord.com/api/oauth2/token",
                new URLSearchParams({
                    client_id: CLIENT_ID,
                    client_secret: CLIENT_SECRET,
                    grant_type: "authorization_code",
                    code: code,
                    redirect_uri: REDIRECT_URI,
                    scope: SCOPE,
                }),
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                }
            );

            const { access_token } = response.data;
            await getUserInfo(access_token);
        } catch (error) {
            console.error("Error getting access token:", error);
            setIsLoading(false);
        }
    }, [isPreview, getUserInfo]);

    useEffect(() => {
        const isCallbackPage = window.location.pathname === '/auth/discord/callback';
        if (isCallbackPage) {
            setIsLoading(true);
            setIsPreview(true);
        }

        const code = new URLSearchParams(window.location.search).get("code");
        if (code && !isPreview) {
            setIsLoading(true);
            getToken(code);
        }
    }, [isPreview, getToken]);

    return (
        <div className="login-container">
            {(isLoading || isPreview) && (
                <div className="loading-card">
                    <div className="loading-content">
                        <div className="discord-logo">
                            <FontAwesomeIcon icon={faDiscord} />
                        </div>
                        <h1 className="success-title">Berhasil Login!</h1>
                        <div className="loading-spinner"></div>
                        <p className="loading-text">Harap tunggu sebentar untuk dialihkan ke halaman terakhir...</p>
                        {isPreview && (
                            <p className="preview-note">
                                Mode Preview - Loading screen akan tetap ditampilkan
                            </p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DiscordLogin;